import { lazy } from "react";
import Loadable from "../../../../../../layout/fullLayout/loadable/loadable";
import { AuthorizedRoute } from "../../../../../../router/AuthorizedRoute";
import { MODULE_IDS } from "../../../../../../constants/enums";

const HabitationalPremiumFinanceListWarpper = Loadable(
  lazy(() =>
    import(
      "./HabitationalPremiumFinanceListWrapper"
    ).then(({ HabitationalPremiumFinanceListWarpper }) => ({
      default: HabitationalPremiumFinanceListWarpper,
    }))
  )
);
const Premium = Loadable(
  lazy(() =>
    import("./HabitationalAutoPremiumFinance").then(
      ({ HabitationalPremiumFinance }) => ({
        default: HabitationalPremiumFinance,
      })
    )
  )
);

export const HabitationalPremiumFinanceRoutes = [
  {
    path: `/habitational-policy/:customerId/premium-finance/:customerPolicyId/`,
    exact: true,
    element: (
      <AuthorizedRoute moduleKeys={[MODULE_IDS.BUSINESS_POLICY]}>
        <HabitationalPremiumFinanceListWarpper />
      </AuthorizedRoute>
    ),
  },
  {
    path: `/habitational-policy/:customerId/premium-finance/:customerPolicyId/manage`,
    exact: true,
    element: (
      <AuthorizedRoute moduleKeys={[MODULE_IDS.BUSINESS_POLICY]}>
        <Premium />
      </AuthorizedRoute>
    ),
  },
  {
    path: `/habitational-policy/:customerId/premium-finance/:customerPolicyId/manage/:premiumNumber`,
    exact: true,
    element: (
      <AuthorizedRoute moduleKeys={[MODULE_IDS.BUSINESS_POLICY]}>
        <Premium />
      </AuthorizedRoute>
    ),
  },
];
